import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BaseApiTemplateService} from '../../shared/base-api-template-service.model';
import {Core2Config} from '../../shared/core2Config';
import {ApiVisa} from '../../shared/api-visa.model';

@Injectable({
  providedIn: 'root'
})
export class ShopifyProductService extends BaseApiTemplateService<any> {

  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ECOMSYNC_PREFIX + 'shopify/products';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ECOMSYNC_PREFIX + 'shopify/products';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ECOMSYNC_PREFIX + 'shopify/products';
    this.httpClient = http;
  }

  createImages(branchGuid: string, dto: any, apiVisa: ApiVisa) {
    if (this.endpoint_path && apiVisa.api_domain_url) {
        this.apiUrl = apiVisa.api_domain_url + this.endpoint_path;
    }
    const url = this.apiUrl + '/create-images' + '?branch_guid=' + branchGuid;
    return this.httpClient.post(url, dto, this.getHttpHeader(apiVisa));
  }

  updateImages(branchGuid: string, dto: any, apiVisa: ApiVisa) {
    if (this.endpoint_path && apiVisa.api_domain_url) {
        this.apiUrl = apiVisa.api_domain_url + this.endpoint_path;
    }
    const url = this.apiUrl + '/upload-images' + '?branch_guid=' + branchGuid;
    return this.httpClient.put(url, dto, this.getHttpHeader(apiVisa));
  }

  deleteImages(branchGuid: string, dto: string, apiVisa: ApiVisa) {
    if (this.endpoint_path && apiVisa.api_domain_url) {
        this.apiUrl = apiVisa.api_domain_url + this.endpoint_path;
    }
    const url = this.apiUrl + '/delete-images' + '?branch_guid=' + branchGuid;
    return this.httpClient.post(url, dto, this.getHttpHeader(apiVisa));
  }

  getImages(branchGuid: string, ecomsyncGuid: any, apiVisa: ApiVisa) {
    if (this.endpoint_path && apiVisa.api_domain_url) {
        this.apiUrl = apiVisa.api_domain_url + this.endpoint_path;
    }
    const url = this.apiUrl + '/images' + `?branch_guid=${branchGuid}&ecom_sync_guid=${ecomsyncGuid}`;
    return this.httpClient.get(url, this.getHttpHeader(apiVisa));
  }

  getGroupProduct(branchGuid: string, apiVisa: ApiVisa) {
    if (this.endpoint_path && apiVisa.api_domain_url) {
        this.apiUrl = apiVisa.api_domain_url + this.endpoint_path;
    }
    const url = this.apiUrl + '/group-products' + `?branch_guid=${branchGuid}`;
    return this.httpClient.get(url, this.getHttpHeader(apiVisa));
  }

  getProductVariant(shopifyProductID: string, branchGuid: string, apiVisa: ApiVisa) {
    if (this.endpoint_path && apiVisa.api_domain_url) {
        this.apiUrl = apiVisa.api_domain_url + this.endpoint_path;
    }
    const url = this.apiUrl + '/single-products' + `?branch_guid=${branchGuid}&shopify_product_id=${shopifyProductID}`;
    return this.httpClient.get(url, this.getHttpHeader(apiVisa));
  }

  getCustomCollection(branchGuid: string, apiVisa: ApiVisa) {
    if (this.endpoint_path && apiVisa.api_domain_url) {
      this.apiUrl = apiVisa.api_domain_url + this.endpoint_path;
    }
    const url = this.apiUrl + '/get-custom-collection' + `?branch_guid=${branchGuid}`;
    return this.httpClient.get(url, this.getHttpHeader(apiVisa));
  }

  updateVariant(branchGuid: string, dto: any, apiVisa: ApiVisa) {
    if (this.endpoint_path && apiVisa.api_domain_url) {
      this.apiUrl = apiVisa.api_domain_url + this.endpoint_path;
    }
    const url = this.apiUrl + '/update-variants' + `?branch_guid=${branchGuid}`;
    return this.httpClient.put(url, dto, this.getHttpHeader(apiVisa));
  }
}
